import pvhApi from '@/api/pvhApi'

const state = () => ({
  tableHeaders: {
    allActive: false,
    headers: [
      {
        title: 'Тип информирования',
        isSortable: false
      }
    ]

  },
  informTypes: [],
  modal: {
    active: false,
    updatedId: null,
    name: '',
    validation: {
      name: {
        type: null,
        message: ''
      }
    }
  },
  pagination: {
    pageList: {
      active: false,
      pages: []
    },
    currentTake: 10,
    currentPage: 1,
    lastPage: 0
  },
  searchValue: '',
  filter: {
    active: false
  },
  isLoading: true,
  responseModal: {
    isActive: false,
    title: '',
    text: '',
    type: ''
  },
  responseModalWithTreaties: {
    isActive: false,
    title: 'Ошибка!',
    text: '',
    type: 'main'
  },
  isActiveDelete: false
})

const getters = {
  '[pvh] getInformTypeList': state => state.informTypes,
  '[pvh] getInformTypeListTableHeaders': state => state.tableHeaders,
  '[pvh] getInformTypeListModal': state => state.modal,
  '[pvh] getInformTypeListIsLoading': state => state.isLoading,
  '[pvh] getInformTypeListSearchValue': state => state.searchValue,
  '[pvh] getInformTypeListFilter': state => state.filter,
  '[pvh] getInformTypeListPagination': state => state.pagination,
  '[pvh] getInformTypeListResponseModal': state => state.responseModal,
  '[pvh] getInformTypeListResponseModalWithTreaties': state => state.responseModalWithTreaties,
  '[pvh] getInformTypeListActiveDelete': state => state.isActiveDelete
}

const mutations = {
  '[pvh] GET_INFORM_TYPE': (state, informTypes) => {
    state.informTypes = informTypes.data.map(informType => {
      return {
        ...informType,
        isControlsActive: false,
        isActive: false
      }
    })
    state.isLoading = false
  },
  '[pvh] SHOW_INFORM_TYPE_LIST_MODAL': (state, itemId) => {
    state.modal.active = true
    if (itemId) {
      const selectedInformType = state.informTypes
        .filter(informType => {
          return informType.id === itemId
        })
        .pop()

      state.modal.updatedId = itemId
      state.modal.name = selectedInformType.name
    }
  },
  '[pvh] SET_INFORM_TYPE_ITEM_NAME': (state, value) => {
    state.modal.name = value
  },
  '[pvh] SET_INFORM_TYPE_ITEM_VALIDATION': (state, valid) => {
    if (valid.name) {
      state.modal.validation.name.message = valid.name[0]
      state.modal.validation.name.type = 'error'
    }
  },
  '[pvh] CLEAR_INFORM_TYPE_MODAL_VALIDATION': (state, inputName) => {
    switch (inputName) {
      case 'name':
        state.modal.validation.name = {
          type: null,
          message: ''
        }
        break
      default:
        break
    }
  },
  '[pvh] CLOSE_INFORM_TYPE_LIST_MODAL': state => {
    state.modal.active = false
    state.modal.updatedId = null
    state.modal.name = ''
    state.modal.validation.name = {
      id: null,
      message: ''
    }
  },

  // pagination
  '[pvh] SET_INFORM_TYPE_LIST_PAGINATION': (state, headers) => {
    state.pagination.currentPage = Number(headers['x-pagination-current-page'])
    state.pagination.lastPage = Number(headers['x-pagination-page-count'])
    // заполняем массив номерами страниц от 1 до последней страницы
    state.pagination.pageList.pages = [...Array(Number(headers['x-pagination-page-count'])).keys()].map(i => ++i)
  },
  '[pvh] RESET_INFORM_TYPE_LIST_CURRENT_PAGE': state => {
    state.pagination.currentPage = 1
  },
  '[pvh] SET_CURRENT_PAGE': (state, pageNum) => {
    state.pagination.currentPage = pageNum
  },

  // search
  '[pvh] SET_INFORM_TYPE_LIST_SEARCH_VALUE': (state, searchValue) => {
    state.searchValue = searchValue
  },

  // filter
  '[pvh] TOGGLE_INFORM_TYPE_LIST_FILTER': state => {
    state.filter.active = !state.filter.active
  },

  // delete checked items
  '[pvh] DELETE_INFORM_TYPE_LIST_CHECKED_ITEMS_SUCCESS': (state) => {
    state.responseModal.isActive = true
    state.responseModal.title = 'Успех!'
    state.responseModal.text = 'Вы успешно удалили способ(ы)'
    state.responseModal.type = 'main'
  },
  '[pvh] DELETE_INFORM_TYPE_LIST_CHECKED_ITEMS_ERROR': (state, errorItems) => {
    let listNamesErrorItems = ''
    errorItems.forEach(e => {
      listNamesErrorItems += ` ${e.name}`
    })
    state.responseModal.isActive = true
    state.responseModal.title = 'Ошибка!'
    state.responseModal.text = `При удалении типа произошла ошибка:${listNamesErrorItems}`
    state.responseModal.type = 'main'
  },

  '[pvh] DELETE_INFORM_TYPE_LIST_CHECKED_ITEMS_TREATIES_ERROR': (state, errorItems) => {
    let listNamesErrorItems = ''
    errorItems.forEach(e => {
      listNamesErrorItems += ` ${e.name}`
    })
    state.responseModalWithTreaties.isActive = true
    state.responseModalWithTreaties.text = `Данные типы используются:${listNamesErrorItems}`
  },
  '[pvh] CLOSE_DELETE_INFORM_TYPE_LIST_MODAL': (state) => {
    state.responseModal.isActive = false
    state.responseModal.title = ''
    state.responseModal.text = ''
    state.responseModal.type = ''
  },
  '[pvh] CLOSE_DELETE_INFORM_TYPE_LIST_MODAL_WITH_TREATIES': (state) => {
    state.responseModalWithTreaties.isActive = false
    state.responseModalWithTreaties.text = ''
  },
  '[pvh] TOGGLE_INFORM_TYPE_LIST_ITEM_ACTIVE': (state, itemId) => {
    const itemsLength = state.informTypes.length
    let counter = 0

    state.informTypes.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isActive = !elem.isActive
      }
      if (elem.isActive) {
        counter += 1
      }
    })

    counter > 0 ? state.isActiveDelete = true : state.isActiveDelete = false

    state.tableHeaders.allActive = counter === itemsLength
  },
  '[pvh] TOGGLE_INFORM_TYPE_LIST_ITEM_ACTIVE_ALL': (state) => {
    state.tableHeaders.allActive = !state.tableHeaders.allActive
    state.tableHeaders.allActive ? state.isActiveDelete = true : state.isActiveDelete = false

    state.informTypes.forEach((elem) => {
      elem.isActive = state.tableHeaders.allActive
    })
  },
  '[pvh] RESET_INFORM_TYPE_LIST_ALL_CHECKS': (state) => {
    state.tableHeaders.allActive = false
    state.isActiveDelete = false
    state.informTypes.forEach((elem) => {
      elem.isActive = state.tableHeaders.allActive
    })
  },
  // reset store
  '[pvh] RESET_INFORM_TYPE_LIST_STORE': (state) => {
    // state.searchValue = ''
    state.sort = {}
    // state.filter = {}
    state.tableHeaders.allActive = false
    state.isActiveDelete = false
    state.pagination.currentPage = 1
  }
}

const actions = {
  '[pvh] getInformType' ({ commit, state }) {
    const params = {
      take: state.pagination.currentTake,
      page: state.pagination.currentPage,
      searchFilter: state.searchValue ? `search[all]=${state.searchValue}` : ''
    }

    pvhApi.getInformType(params)
      .then(response => {
        commit('[pvh] GET_INFORM_TYPE', response.data)
        commit('[pvh] SET_INFORM_TYPE_LIST_PAGINATION', response.headers)
        state.isLoading = false
      })
      .catch(error => {
        console.log('ошибка получения списка информационных типов', error)
      })
  },
  '[pvh] saveInformTypeItem' ({ commit, state }) {
    if (!state.modal.updatedId) {
      const createData = {
        name: state.modal.name
      }
      pvhApi.postInformType(createData)
        .then(response => {
          commit('[pvh] CLOSE_INFORM_TYPE_LIST_MODAL')
          this.dispatch('[pvh] getInformType')
        })
        .catch(error => {
          commit('[pvh] SET_INFORM_TYPE_ITEM_VALIDATION', error.response.data.errors)
          console.log('Ошибка обновления информационных типов', error.response)
        })
    } else {
      const updateData = {
        name: state.modal.name
      }

      pvhApi.putInformType(updateData, state.modal.updatedId)
        .then(response => {
          commit('[pvh] CLOSE_INFORM_TYPE_LIST_MODAL')
          this.dispatch('[pvh] getInformType')
        })
        .catch(error => {
          commit('[pvh] SET_INFORM_TYPE_ITEM_VALIDATION', error.response.data.errors)
          console.log('Ошибка обновления информационных типов', error.response)
        })
    }
  },
  '[pvh] toggleInformTypeListItemActive' ({ commit }, itemId) {
    commit('[pvh] TOGGLE_INFORM_TYPE_LIST_ITEM_ACTIVE', itemId)
  },
  '[pvh] toggleInformTypeListItemActiveAll' ({ commit }) {
    commit('[pvh] TOGGLE_INFORM_TYPE_LIST_ITEM_ACTIVE_ALL')
  },
  '[pvh] showInformTypeModal' ({ commit }, itemId) {
    commit('[pvh] SHOW_INFORM_TYPE_LIST_MODAL', itemId)
  },
  '[pvh] setInformTypeItemName' ({ commit }, value) {
    commit('[pvh] SET_INFORM_TYPE_ITEM_NAME', value)
  },
  '[pvh] clearInformTypeModalValidation' ({ commit }, inputName) {
    commit('[pvh] CLEAR_INFORM_TYPE_MODAL_VALIDATION', inputName)
  },
  '[pvh] closeInformTypeModal' ({ commit }) {
    commit('[pvh] CLOSE_INFORM_TYPE_LIST_MODAL')
  },
  '[pvh] removeInformType' ({ commit }, itemId) {
    pvhApi.deleteInformType(itemId)
      .then(response => {
        this.dispatch('[pvh] getInformType')
      })
      .catch(error => {
        console.log('Ошибка удаления информационного типа:' + error)
      })
  },

  // pagination
  '[pvh] getInformTypeListPage' ({ commit }, pageNum) {
    commit('[pvh] SET_CURRENT_PAGE', pageNum)
    this.dispatch('[pvh] getInformType')
  },

  // search
  '[pvh] setInformTypeListSearchValue' ({ commit }, searchValue) {
    commit('[pvh] SET_INFORM_TYPE_LIST_SEARCH_VALUE', searchValue)
    commit('[pvh] RESET_INFORM_TYPE_LIST_CURRENT_PAGE')
    this.dispatch('[pvh] getInformType')
  },

  // delete checked items
  '[pvh] deleteInformTypeListCheckedItems' ({ commit, state }) {
    const checkedItems = []
    const errorItems = []
    const treatiesItems = []
    state.informTypes.forEach((e) => {
      if (e.isActive && e.clients === null) {
        checkedItems.push(e)
      } else if (e.isActive && e.clients.length > 0) {
        treatiesItems.push(e)
      }
    })

    if (treatiesItems.length > 0) {
      commit('[pvh] RESET_INFORM_TYPE_LIST_ALL_CHECKS')
      commit('[pvh] DELETE_INFORM_TYPE_LIST_CHECKED_ITEMS_TREATIES_ERROR', treatiesItems)

      treatiesItems.forEach((e) => {
        e.isActive = false
      })
    }

    async function processMessages (array) {
      for (const item of array) {
        await pvhApi.deleteInformType(item.id).then((response) => {
        }).catch(error => {
          errorItems.push(item)
          console.log('Ошибка удаления информационного типа', error)
        })
      }
    }

    if (checkedItems.length > 0) {
      processMessages(checkedItems).then(() => {
        if (errorItems.length > 0) {
          commit('[pvh] RESET_INFORM_TYPE_LIST_ALL_CHECKS')
          commit('[pvh] DELETE_INFORM_TYPE_LIST_CHECKED_ITEMS_ERROR', errorItems)
          this.dispatch('[pvh] getInformType')
        } else {
          commit('[pvh] RESET_INFORM_TYPE_LIST_ALL_CHECKS')
          commit('[pvh] DELETE_INFORM_TYPE_LIST_CHECKED_ITEMS_SUCCESS')
          this.dispatch('[pvh] getInformType')
        }
      })
    }
  },
  '[pvh] closeInformTypeListDeleteModal' ({ commit }) {
    commit('[pvh] CLOSE_DELETE_INFORM_TYPE_LIST_MODAL')
  },
  '[pvh] closeListDeleteModalWithTreaties' ({ commit }) {
    commit('[pvh] CLOSE_DELETE_INFORM_TYPE_LIST_MODAL_WITH_TREATIES')
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
